import { ClockContext, ClockProvider } from '../../../ui/clock/clock';
import { useContext } from 'react';
import { useAppSelector } from '../../list-page/data/store';

interface IProductClockProps{
    saleEndDate: Date,
    textColor?: string,
    showSeconds?: boolean,
    prefixText?:string,
    clockSeparator?:string /* 'default' or undefind: {23:59:59} | 'style-h-m-s' : {23h 59m 59s}*/
}

/**
 * product clock HTML
 */
const ProductClockInner = () => {

    const {
        hour,
        minute,
        sec,
        mode,
        textColor,
        showSeconds,
        prefixText,
        clockSeparator
    } = useContext(ClockContext);
    return (
        <>
            {
                mode === 'on' && !clockSeparator &&
                <div className={`flex items-center font-bold text-center ${ textColor }`}>
                    {prefixText && <span>{prefixText}&nbsp;</span>}
                    <div className="">
                        <span>{ hour }</span>
                        <span style={{ margin: '2px'}}>:</span>
                        <span>{ minute }</span>
                        {
                            showSeconds &&
                            <>
                                <span style={{ margin: '2px'}}>:</span>
                                <span>{ sec }</span>
                            </>
                        }
                    </div>
                </div>
            }
            {
                mode === 'on' && clockSeparator === 'style-h-m-s' &&
                <div className={`flex items-center font-bold text-center ${ textColor }`}>
                    {prefixText && <span>{prefixText}&nbsp;</span>}
                    <div className="">
                        <span>{ hour }h&nbsp;</span>
                        <span>{ minute }m&nbsp;</span>
                        {
                            showSeconds &&
                            <>
                                <span>{ sec }s</span>
                            </>
                        }
                    </div>
                </div>
            }
        </>
    )
};

/**
 * product clock provider
 */
const ProductClock = (props: IProductClockProps) => {

    const localTime = useAppSelector(store => store.localTime);

    return (
        <ClockProvider
            {...props}
            localTime={ localTime }
            saleEndDate={ props.saleEndDate }>
            <ProductClockInner/>
        </ClockProvider>
    )
};

export default ProductClock;